import Vue from 'vue'
import "babel-polyfill"
import vuex from 'vuex'
// import demo from './modules/demo.js' // 引入demo组件需要的数据store对象

import userInfo from './modules/userInfo.js' //引入用户信息

Vue.use(vuex)

export default new vuex.Store({
  // state: state, mutations: mutations, actions: actions
  modules: {
    // demo,
    userInfo,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js